import * as React from 'react'

import { Box, Icon, Spinner, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { BreakConfigurationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import ArchivedItem from './ArchivedItem'

interface Props {
  archivedBreakConfigurations: BreakConfigurationFragment[]
  loading: boolean
}

const ArchivedBreaks = ({ archivedBreakConfigurations, loading }: Props) => {
  const [open, setOpen] = React.useState(false)
  const [openInfo, toggleOpenInfo] = useToggle()

  return (
    <>
      {archivedBreakConfigurations.length ? (
        <Box gap="s16">
          <Box flexDirection="row" alignItems="center" gap="s8">
            <Box
              flexDirection="row"
              alignItems="center"
              gap="s8"
              cursor="pointer"
              onClick={() => setOpen(!open)}
            >
              <Icon.Small icon={open ? 'caret-up' : 'caret-down'} color="grey1000" />

              <Text.Normal size="200" weight="semibold" color="grey1000">
                {i18n.t('break_types.actions.archived_breaks')}
              </Text.Normal>

              <Tooltip.Alt
                attachment="bottom center"
                targetAttachment="top center"
                open={openInfo}
                toggle={toggleOpenInfo}
                label={i18n.t('break_types.actions.archived_message')}
              >
                <Icon.Medium icon="info-circle-line" color="grey1000" />
              </Tooltip.Alt>
            </Box>
          </Box>

          {open && loading && (
            <Box alignItems="center" width="full" padding="s32">
              <Spinner />
            </Box>
          )}

          {open && !loading && (
            <Box
              width="full"
              paddingY="s16"
              paddingX="s24"
              gap="s8"
              component="ul"
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  width: 's1',
                  color: 'grey400',
                  style: 'solid',
                },
              }}
            >
              {archivedBreakConfigurations.map((breakConfiguration) => (
                <ArchivedItem breakConfiguration={breakConfiguration} key={breakConfiguration.id} />
              ))}
            </Box>
          )}
        </Box>
      ) : (
        <Box></Box>
      )}
    </>
  )
}

export default observer(ArchivedBreaks)
